<template>
  <v-card flat style="border: 1px solid grey">
    <v-data-table
      :loading="isLoading"
      :headers="tableHeaders"
      :items="items"
      style="border-color: red"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            {{ props.index + 1 }}
          </td>
          <td>
            {{ props.item.orders_code }}
          </td>
          <td
            class="text-xs-center"
            :style="{
              fontWeight: 'bold',
              color: props.item.orders_type == 1 ? '#141414' : 'grey',
            }"
          >
            {{ props.item.orders_type == 1 ? "Food" : "Messenger" }}
          </td>

          <td class="text-xs-center">
            {{ props.item.orders_place_start }}
          </td>
          <td class="text-xs-center">
            {{ props.item.orders_place_end }}
          </td>
          <td
            class="text-xs-center"
            style="white-space: nowrap; color: green; font-weight: bold"
          >
            {{ `฿ ${props.item.orders_total_price}` }}
          </td>
          <td class="text-xs-center">
            {{
              moment(props.item.orders_datetime_service).format(
                "DD-MM-YYYY HH:mm"
              )
            }}
          </td>
          <td class="text-xs-center">
            {{
              moment(props.item.orders_datetime_service_end).format(
                "DD-MM-YYYY HH:mm"
              )
            }}
          </td>
          <td class="text-xs-center">
            <v-btn icon @click="$emit('toEdit', props.item.orders_id)"
              ><v-icon>edit</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import moment from "moment";
export default {
  props: {
    isLoading: {
      default() {
        return false;
      },
    },
    items: {
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      tableHeaders: [
        {
          text: "#",
          align: "center",
          value: "product_code",
          sortable: false,
        },
        {
          text: "Order Code",
          align: "center",
          value: "orders_code",
          sortable: false,
        },
        {
          text: "Type",
          align: "center",
          value: "order_type",
          sortable: false,
        },
        {
          text: "Start",
          align: "center",
          value: "orders_place_start",
          sortable: false,
        },
        {
          text: "End",
          align: "center",
          value: "orders_place_end",
          sortable: false,
        },
        {
          text: "Total Price",
          align: "center",
          value: "orders_total_price",
          sortable: false,
        },
        {
          text: "Date/Time Start",
          align: "center",
          value: "action",
          sortable: false,
        },
        {
          text: "Date/Time End",
          align: "center",
          value: "action",
          sortable: false,
        },
        {
          text: "",
          align: "center",
          value: "action",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    moment,
  },
};
</script>

<style lang="scss" scoped>
</style>